import { useEffect, useState } from 'react';

/**
 * Returns true once the user has scrolled down from the very top of the page,
 * false again when they return to scrollY === 0.
 *
 * Used by HeaderClearChoice2 to hide the top alert banner after the first
 * scroll tick so only the nav bar remains fixed at the top of the viewport.
 */
export const useScrolledFromTop = (): boolean => {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => setIsScrolled(typeof window !== 'undefined' && globalThis.scrollY > 0);
		globalThis.addEventListener('scroll', handleScroll, { passive: true });
		// Sync immediately in case the page is already scrolled on mount
		handleScroll();
		return () => globalThis.removeEventListener('scroll', handleScroll);
	}, []);

	return isScrolled;
};
